import { useState } from "react";
import BrandInformationForm from "./components/BrandInfoForm";
import TenantDetailForm from "./components/TenantInfoForm";
import Dropdown from "../../components/dropdown/Index";
import useMallTenantDropdown from "../../hooks/useMallTenantDropdown";

export default function Index() {
  const [activeTab, setActiveTab] = useState("brand");
  const {
    mallOptions,
    tenantOptions,
    brandOptions,
    selectedMall,
    selectedTenant,
    selectedBrand,
    setSelectedMall,
    setSelectedTenant,
    setSelectedBrand,
  } = useMallTenantDropdown();

  const tabs = [
    { id: "brand", label: "Brand Information" },
    { id: "tenant", label: "Tenant Information" },
  ];

  return (
    <div className="min-h-screen bg-white dark:bg-gray-900">
      <div className="p-4 sm:p-6 space-y-4 sm:space-y-6">
        <Dropdown
          mallSelected={setSelectedMall}
          mallOptions={mallOptions}
          tenantSelected={setSelectedTenant}
          tenantOptions={tenantOptions}
          mallValue={selectedMall}
          tenantValue={selectedTenant}
          brandSelected={setSelectedBrand}
          brandOptions={brandOptions}
          brandValue={selectedBrand}
        />

        <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-700">
          <div className="block sm:hidden">
            <select
              value={activeTab}
              onChange={(e) => setActiveTab(e.target.value)}
              className="w-full border border-gray-200 dark:border-gray-700 rounded-xl  px-4 py-2.5 text-sm font-semibold text-gray-800 dark:text-gray-200 bg-white dark:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              {tabs.map((tab) => (
                <option key={tab.id} value={tab.id}>
                  {tab.label}
                </option>
              ))}
            </select>
          </div>

          <div className="hidden sm:block border-b border-gray-100 dark:border-gray-700">
            <ul className="flex flex-wrap gap-2 mx-6 my-4">
              {tabs.map((tab) => (
                <li key={tab.id}>
                  <button
                    className={`whitespace-nowrap font-semibold rounded-xl px-4 py-2.5 text-sm border transition-colors duration-200 ${
                      activeTab === tab.id
                        ? "bg-blue-600 text-white border-blue-700"
                        : "bg-white text-gray-800 border-gray-200 hover:text-gray-900 hover:border-gray-300 dark:bg-gray-800 dark:text-gray-200 dark:border-gray-700"
                    }`}
                    onClick={() => setActiveTab(tab.id)}
                    type="button"
                  >
                    {tab.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="tab-content relative">
            <div className={activeTab === "brand" ? "block" : "hidden"}>
              <BrandInformationForm tenantId={selectedTenant} brandId={0} />
            </div>
            <div className={activeTab === "tenant" ? "block" : "hidden"}>
              <TenantDetailForm tenantId={selectedTenant} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
